export default {
  avatar: {
    title: "Modifica Avatar",
  },
  bindRole: {
    allServers: "Tutti i Server",
    bindFailed: "Collegamento personaggio fallito",
    bindSuccess: "Personaggio Collegato",
    getRoleListFailed: "Recupero elenco personaggi fallito",
    getServerListFailed: "Recupero elenco server fallito",
    modifyTitle: "Cambia Personaggio Collegato",
    noRole: "Nessun personaggio disponibile",
    recentServers: "Il tuo Server",
    role: "Nome Personaggio:",
    rolePlaceholder: "Seleziona Personaggio",
    server: "Server:",
    serverPlaceholder: "Seleziona Server",
    title: "Collega Personaggio",
  },
  commentModal: {
    placeholder: "Commenta...",
    replyTo: "Rispondi a {username}",
    title: "Commento",
  },
  common: {
    cancel: "Annulla",
    confirm: "Conferma",
    landscapeTip: "Ruota il telefono in modalità verticale per un'esperienza migliore",
    loadMore: "Scorri per caricare altro",
    loading: "Caricamento...",
    loadingMore: "Carica altro...",
    noMore: "Nessun altro contenuto",
    refreshFailed: "Aggiornamento fallito",
    refreshSuccess: "Aggiornato",
    submit: "Invia",
    all: "Tutti",
    language: "Lingua",
  },
  error: {
    50002: "Token non valido o scaduto",
    50006: "Nickname già in uso.",
    50007: "Puoi cambiare il nickname solo una volta al mese, l'hai già modificato questo mese",
    50008: "Punti insufficienti.",
    50301: "Non disponi dei permessi per pubblicare",
    50302: "Limite post raggiunto",
    50303: "La lunghezza del contenuto non soddisfa i requisiti",
    50304: "Il testo contiene linguaggio inappropriato, modificalo e riprova.",
    50308: "Non puoi visualizzare questo post",
    50309: "Post eliminato o spostato",
    50351: "Discussione chiusa, impossibile rispondere",
    50353: "Non disponi dei permessi per rispondere",
    50354: "Non è consentito rispondere in questa sezione",
    50355: "Pubblicazione troppo frequente, riprova più tardi",
    50356: "Limite post orario raggiunto",
    50361: "Commento non trovato",
    50500: "La funzione Cerca non è ancora disponibile",
    50501: "Funzione Cerca disattivata",
    50502: "Il testo contiene linguaggio inappropriato, modificalo e riprova.",
    50505: "Ricerca troppo frequente, riprova più tardi",
    50703: "Immagine non approvata.",
    50704: "Contenuto dell'immagine non idoneo.",
    50214: "Condivisione non riuscita: non fai parte di alcuna @:shareModal.alliance.",
    common: "Operazione non riuscita. Riprova più tardi.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Accesso effettuato",
    loginInSuccess: "Accesso effettuato",
    pleaseLogin: "Effettua prima l'accesso",
    loginNow: "Accedi",
    pullToRefresh: "Scorri per aggiornare",
    releaseToRefresh: "Rilascia per aggiornare",
    signFailed: "Accesso non riuscito",
    signIn: "Accedi",
    signInFailedTip: "Accesso non riuscito, riprova più tardi",
    signSuccess: "Accesso riuscito",
    goToShop: "Vai al Centro Punti",
    sortByLastPost: "Commenti recenti",
    sortByTime: "Recenti",
    tags: {
      activity: "Evento",
      chats: "Discussione",
      guide: "Guida",
      recommend: "Consigliato",
      news: "Notizie",
    },
    unboundRole: "Personaggio non associato",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "In manutenzione",
    message: "Ci scusiamo, il forum del gioco è attualmente in manutenzione. Si prega di riprovare più tardi.",
  },
  mentionModal: {
    searchPlaceholder: "Cerca utente",
    title: "Seleziona Utente",
  },
  nicknameModify: {
    alreadyRenamed:
      "Hai già cambiato il nickname questo mese. È consentita una sola modifica al mese.",
    changedNickname: "Modifica Nickname",
    cost: "Costo",
    date: "Data",
    getMore: "Ottieni",
    nicknameTooShort: "Il nickname deve avere almeno 3 caratteri",
    coinNotEnough: "Punti insufficienti",
    placeholder: "Inserisci Nickname",
    recordTitle: "Cronologia Modifiche",
    sameNickname: "Il nuovo nickname non può essere uguale a quello attuale.",
    success: "Modifiche salvate",
    viewRecord: "Cronologia Modifiche",
  },
  notice: {
    empty: "Nessun messaggio",
    likeComment: "A {username} piace il tuo commento",
    likePost: "A {username} è piaciuto il tuo post",
    mentionComment: "{username} ha menzionato il tuo commento",
    mentionPost: "{username} ha menzionato il tuo post",
    replyComment: "{username} ha risposto al tuo commento",
    replyPost: "{username} ha risposto al tuo post",
    system: "Avviso di sistema",
    tabs: {
      like: "Mi piace",
      mention: "Menzioni",
      notification: "Notifica",
      reply: "Risposte",
    },
    title: "Notifica Messaggi",
  },
  operateModal: {
    confirmDelete: "Sei sicuro di voler eliminare questo post?",
    copyFailed: "Copia fallita",
    copyLink: "Copia Link",
    copySuccess: "Copiato",
    delete: "Elimina",
    shareToGame: "Condividi nel gioco",
    deleteFailed: "Eliminazione Fallita",
    deleteSuccess: "Eliminazione Completata",
    title: "Azione",
  },
  shareModal: {
    selectChannelTitle: "Seleziona il canale in cui condividere",
    channelLabel: "Canale",
    channelPlaceholder: "Seleziona canale",
    alliance: "Alleanza",
    shareSuccess: "Condiviso con successo",
    continueBrowse: "Continua a navigare",
    goToGame: "Vedi nel gioco",
    noThreadTip: "Apri prima un post",
  },
  post: {
    create: {
      contentEmpty: "Il contenuto non può essere vuoto",
      contentPlaceholder: "Scrivi qualcosa...",
      failed: "Pubblicazione fallita",
      fileTooLarge: "Dimensioni file eccessive (max {maxSize})",
      image: "Immagine",
      imageSizeLimit: "L'immagine non deve superare i 5 MB",
      imageUploadFailed: "Impossibile caricare l'immagine",
      imageUploadSuccess: "Immagine Caricata",
      imageUploading: "Caricamento immagine...",
      invalidFileType: "File non supportato",
      maxCharsReached: "Limite caratteri raggiunto ({max} caratteri)",
      mention: "{'@'}",
      selectBoard: "Seleziona Sezione",
      topicLabel: "Argomento",
      submit: "Pubblica",
      submitting: "Pubblicando...",
      success: "Pubblicato",
      title: "Bacheca",
      titleEmpty: "Il titolo non può essere vuoto",
      titlePlaceholder: "Inserisci titolo",
      video: "Video",
      videoSizeLimit: "Il video non deve superare i 50 MB",
      videoUploadFailed: "Impossibile caricare il video",
      videoUploadSuccess: "Video Caricato",
      videoUploading: "Caricamento video...",
    },
    title: "Pubblica",
  },
  postDetail: {
    allComments: "Tutte le {num} risposte",
    allReplies: "Rispondi a tutti",
    author: "Autore",
    cancelFavorite: "Rimosso dai Preferiti",
    commentTooShort: "Il commento deve contenere almeno 5 caratteri",
    translate: "Traduci",
    translating: "Traduzione in corso...",
    translateSuccess: "Traduzione completata",
    translateFailed: "Traduzione fallita",
    translatedTo: "Tradotto in",
    earliest: "Meno Recenti",
    favoriteSuccess: "Aggiunto ai Preferiti",
    floor: "Floor",
    latest: "Più Recenti",
    loadFailed: "Caricamento non riuscito",
    noContent: "Nessun Contenuto",
    onlyAuthor: "Solo Autore",
    reply: "Rispondi",
    replyTo: "Rispondi",
    sendFailed: "Invio non riuscito",
    sendSuccess: "Inviato",
    sending: "Invio...",
    viewOriginalPost: "Post Originale",
    writeSomething: "Scrivi qualcosa...",
  },
  profile: {
    addLikeSuccess: "Ti piace",
    cancelLikeSuccess: "Non mi piace più",
    communityId: "ID Comunità",
    editNickname: "Cambia Nickname",
    followSuccess: "Seguiti",
    followed: "Seguiti",
    followers: "Follower",
    follow: "Segui",
    likes: "Mi piace",
    noFavorites: "Nessun Preferito",
    noPosts: "Nessuna Novità",
    shopLabel: "Negozio Punti",
    tabs: {
      favorites: "I miei preferiti",
      posts: "I miei aggiornamenti",
    },
    title: "Profilo",
    unfollowSuccess: "Non segui più",
  },
  search: {
    btn: "Cerca",
    empty: "Nessun contenuto correlato",
    filter: {
      dateline: "Recenti",
      title: "Ordina",
      views: "Popolari",
    },
    historyTitle: "Cronologia Ricerche",
    hotTitle: "Tendenze",
    relatedPosts: "Post Correlati",
    tabs: {
      post: "Pubblica",
      user: "Utente",
    },
  },
  setting: {
    about: "Chi Siamo",
    logout: "Disconnetti",
    logoutSuccess: "Disconnesso",
    privacy: "Informativa sulla Privacy",
    service: "Termini di Servizio",
    title: "Impostazioni",
  },
  shop: {
    emptyTip: "Negozio in arrivo!",
    record: "Cronologia Scambi",
    title: "Centro Scambi",
    bindRole: "Associa Personaggio",
    switchRole: "Cambia Personaggio",
    tabs: {
      tasks: "Missioni punti",
      rewards: "Scambio ricompense",
    },
    taskInProgress: "In corso",
    taskCompleted: "Completato",
    goToComplete: "Miss.",
    exchange: "Scambia",
    exchanged: "Scambiato",
    exchangeConfirmTitle: "Confermare lo scambio?",
    currentCoins: "Punti attuali",
    costCoins: "Punti da consumare",
    receiveRole: "Personaggio destinatario",
    exchangeSuccess: "Scambio riuscito",
    exchangeFailed: "Scambio fallito",
  },
  exchangeRecord: {
    time: "Tempo",
    content: "Contenuto",
    points: "Punti",
    empty: "Nessuna cronologia di scambio",
  },
  tabBar: {
    home: "Home",
    notice: "Messaggi",
    profile: "Profilo",
  },
  time: {
    hoursAgo: "{hours} ore fa",
    minutesAgo: "{minutes} min fa",
  },
};
